//
// main_swiper.js
// Theme module
//

'use strict';

//
// Functions
//

(function (waTheme) {

    let customOptions = {
        on: {
            slideChangeTransitionEnd: function (event) {
                let $el = $(event.$el);
                let $slider = $el.parents(".b-home-slider");

                if ($slider.hasClass("b-home-slider--02")) {
                    console.log($el.find(".swiper-slide-active").data("bs-theme"));
                    let theme_color = $el.find(".swiper-slide-active").data("bs-theme");
                    let theme_color_inverted = theme_color === "light" ? "dark" : "light";

                    $(".l-desktop-header").attr("data-bs-theme", theme_color);
                    // $(".b-search__input").attr("data-bs-theme", theme_color_inverted);
                    // console.log(event);
                }
            },
        }
    }

    new window.waTheme.init.site.Swiper({
        wrapper: document.querySelectorAll(`.b-home-slider .swiper`),
        custom_options: customOptions,
    });

})(window.waTheme);
